module.exports = __webpack_public_path__ + "images/feature/template-2-662988b11d769bc64ad72af2dc5df26a.jpg";